import React, { useState, useEffect } from "react";
import { ReactComponent as SunIcon } from "./Sun.svg"; // استخدم الأيقونات SVG الخاصة بك
import { ReactComponent as MoonIcon } from "./Moon.svg"; // استخدم الأيقونات SVG الخاصة بك
import "./DarkMode.css";

const DarkMode = () => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        return localStorage.getItem('theme') === 'dark';
    });

    useEffect(() => {
        const theme = isDarkMode ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [isDarkMode]);

    const toggleDarkMode = () => {
        setIsDarkMode(prevMode => !prevMode);
    };

    return (
        <label className="ui-switch">
            <input
                type="checkbox"
                checked={isDarkMode}
                onChange={toggleDarkMode}
            />
            <div className="slider">
                <div className="circle"></div>
                <div className="icon-container">

                </div>
            </div>
        </label>
    );
};

export default DarkMode;
